import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-business-income-return-en-v2',
    templateUrl: './business-income-return-en-v2.component.html',
    styleUrls: ['./business-income-return-en-v2.component.css'],
    standalone: false
})
export class BusinessIncomeReturnEnV2Component implements OnInit, OnChanges {
  result1: number;

  constructor() { }

  @Input() returnData
  @Input() printActive: boolean

  data: any
  totalAssets: number
  closingCapital: number
  totalAssetsAndLiabilities: number
  businessAvailable: boolean = false

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges){
    this.data = this.returnData?.headSummery?.businessSummeryData?.businessDetails    
    this.totalAssets = (this.data?.cashHandBank ?? 0) + (this.data?.inventories ?? 0) + (this.data?.fixedAssets ?? 0) + (this.data?.otherAssets ?? 0)
    this.closingCapital = (this.data?.openingCp ?? 0) + (this.data?.netProfit ?? 0) - (this.data?.withdrawalsIncmYr ?? 0)
    this.totalAssetsAndLiabilities = (this.closingCapital ?? 0) + (this.data?.liabilities ?? 0)
    this.businessAvailable = this.returnData?.headSummery?.incomeHeadsList?.filter((item)=>item === 'Income from Business')[0] ? true : false    
    let grossProfitValue = this.data?.grossProfit ?? 0;
    let gasoExpensesValue = this.data?.gasoExpenses ?? 0;
    this.result1 = grossProfitValue - gasoExpensesValue;
  }

}
